import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to top on every navigation change (including back/forward)
    try {
      if (typeof window !== "undefined" && window.scrollTo) {
        window.scrollTo({ top: 0, left: 0, behavior: "auto" });
      }
    } catch (e) {
      console.error("ScrollToTop error:", e);
    }
  }, [pathname]);

  return null;
};

export default ScrollToTop;
